import { render, staticRenderFns } from "./settings-all.vue?vue&type=template&id=ddc11a0e&scoped=true&"
import script from "./settings-all.vue?vue&type=script&lang=ts&"
export * from "./settings-all.vue?vue&type=script&lang=ts&"
import style0 from "./settings-all.vue?vue&type=style&index=0&id=ddc11a0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc11a0e",
  null
  
)

export default component.exports